import { RootState } from '../root.reducers';
import { RadiusParserOptions } from './radiusParserOptions.types';

export const getRadiusParserOptionsList = (state: RootState): RadiusParserOptions[] =>
  state.radiusParserOptions.entities;

export const getRadiusParserOptions = (state: RootState): RadiusParserOptions | null =>
  state.radiusParserOptions.single;

export const getSelectedRadiusParserOptions = (state: RootState): RadiusParserOptions[] =>
  state.radiusParserOptions.selected;

export const getRadiusParserOptionsCreatedId = (state: RootState): string | null =>
  state.radiusParserOptions.createdId;

export const isRadiusParserOptionsCreatePopupOpen = (state: RootState): boolean =>
  state.radiusParserOptions.ui.isCreatePopupOpen;

export const isRadiusParserOptionsLoading = (state: RootState): boolean =>
  state.radiusParserOptions.ui.isLoading;

export const isRadiusParserOptionsSaving = (state: RootState): boolean =>
  state.radiusParserOptions.ui.isSaving;
